var _style, _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvataricon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1249.2 1249.2",
    style: {
      enableBackground: "new 0 0 1249.2 1249.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6A632;}\n\t.st1{fill:#E73964;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#F4F4F4;}\n\t.st4{fill:#A8A8A8;}\n\t.st5{fill:url(#SVGID_00000160883619617591791470000014148425762864319401_);}\n\t.st6{fill:url(#SVGID_00000034801566128519806750000006263822742315374507_);}\n\t.st7{fill:url(#SVGID_00000100352243880319835640000014181760514276584581_);}\n\t.st8{fill:url(#SVGID_00000171680330927140640210000003715242568628861617_);}\n\t.st9{fill:#EAEAEA;}\n\t.st10{fill:#F9F7F7;}\n\t.st11{fill:#A0A0A0;}\n\t.st12{fill:url(#SVGID_00000027579047850633664450000008372711311189066913_);}\n\t.st13{fill:url(#SVGID_00000070801985034448268720000014064554511017984932_);}\n\t.st14{fill:url(#SVGID_00000011723063245073267170000015245553520251823546_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_00000052080746727364158900000007135900938915726986_);}\n\t.st17{fill:url(#SVGID_00000168114975181857639780000017511042469361666712_);}\n\t.st18{fill:url(#SVGID_00000080887802385440611440000000829525552151589264_);}\n\t.st19{fill:url(#SVGID_00000008145755614208892480000016610259366766761104_);}\n\t.st20{fill:url(#SVGID_00000098194052648182784940000011690571692134141886_);}\n\t.st21{fill:url(#SVGID_00000177473655845364340230000000732301403377933730_);}\n\t.st22{fill:url(#SVGID_00000160901985260601195340000015569643463942369696_);}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1249.2,
    height: 1248.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.9418,
    y1: 1046.0516,
    x2: 847.3984,
    y2: 1046.0516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05779973,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1872,
    style: {
      stopColor: "#D4D4D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3108,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4253,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6449,
    style: {
      stopColor: "#FCFCFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#DFDFDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    style: {
      stopColor: "#C6C6C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M847.4,1127.7c-143.9-51-289.4-49.3-434.5,0V991.5c146-37.4,290.8-34.9,434.5,0V1127.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108999404501363049380000013368096290268745104_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.1702,
    y1: 1275.3776,
    x2: 636.1702,
    y2: 824.185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#F0F0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9463,
    style: {
      stopColor: "#C1C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108999404501363049380000013368096290268745104_)"
    },
    d: "M786.3,875.5 c-10.9-0.1,8.7,138,18.8,171.1c22.9,75.5,303.3,139.4,305.4,189.5c0.5,13.1,0,13.1,0,13.1H161.7l88.3-85l67.2-17.4L353,1130 c6.9-3.3,13.4-7.2,19.5-11.8l73.5-55.8c0,0,23-28.8,21.1-72.4c-1.9-43.6-1.9-114.5-1.9-114.5H786.3z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.6,662.8c0,0-50.3-93.7-59.1-108.3c-8.8-14.6,6.6-64.5,0-74.9c-6.6-10.4-8.8-162.3,44.2-208.1 c53-45.8,84-58.3,84-58.3c13.1-11.3,100.5-43.2,137.2-37.5c110.5,17.4,92.1,11.7,112.5,10.4c46.9,7.6,82.7,20.2,77.2,50.9 c17.7-9.1,31.7-9.2,46.6,1.1c-4.1,8.7-4.6,14.4,0,18.7c0,0,57.5,2.1,57.5,145.7c0,138.3-10.7,187.7-26.5,195.6 c-15.8,7.9-44.9,36-44.9,36S840.5,384,769.8,386s-122.5,37.6-293.9,0C438.3,377.7,384.7,612.9,404.6,662.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M398.8,750.8c0,0,30.5,149.3,107,195.6c119.5,72.4,201.6,11,201.6,11s95.4-85.5,111-135.9 c14-45,18.9-70.8,18.9-70.8s12.6,0,21-10.4c8.4-10.4,10.5-77,16.8-95.7c6.3-18.7,10.5-49.9-10.5-47.9c-21,2.1-31.5,37.5-31.5,37.5 s19-62.9,6.5-100.4c-12.6-37.5-4.4-116-54.7-147.3c-50.4-31.2-114.5-20.8-145.4-10.4c-30.9,10.4-95.9,4.2-135.8-10.4 s-84.4,51.7-90.7,82.9s-16.3,160.6-14.2,185.6c2.1,25,2.1,25,2.1,25s-14.7-66.6-27.3-70.8c-12.6-4.2-35.7-4.2-31.5,45.8 c4.2,49.9,9.3,11.3,27.3,104.1C379.9,792.5,398.8,750.8,398.8,750.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M412.7,992.5c0,0-18.3,107.6-30,110.6c-11.7,3,130,72.8,182.1,79.5c0,0,31.3-54.2,66.4-70.6 C631.1,1112.1,419.9,1040.4,412.7,992.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M847.8,991.5c0,0,19.2,107.4,30.8,110.3c11.6,2.9-127.8,74.2-179.2,81.5c0,0-31.5-53.8-66.4-69.8 C633.1,1113.5,841.2,1039.5,847.8,991.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvataricon01);
export default __webpack_public_path__ + "static/media/avatar icon-01.bdf4a3a88ed30537c967731171bcea74.svg";
export { ForwardRef as ReactComponent };